export default function injectStyle(url, id) {
  if (document.getElementById(id)) {
    return null
  }
  const fileref = document.createElement('link')

  fileref.setAttribute('type', 'text/css')
  fileref.setAttribute('rel', 'stylesheet')
  fileref.setAttribute('href', url)
  fileref.id = id

  return document.head.appendChild(fileref)
}
